// extracted by mini-css-extract-plugin
export default {"Box":"OfferRequestsInfo_Box__PpWBm"};